<div class="search-container">
  <h1>ドキュメント検索</h1>
  <div class="search-input">
    <input type="text" [(ngModel)]="searchTerm" placeholder="検索キーワードを入力してください" (keyup.enter)="searchDocuments()">
    <button (click)="searchDocuments()" [disabled]="loading">
      <span *ngIf="loading">検索中...</span>
      <span *ngIf="!loading">検索</span>
    </button>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <div *ngIf="searchResults && !loading">
    <div class="summary" [innerHTML]="searchResults.summary"></div>
    <ul class="document-list">
      <li *ngFor="let document of searchResults.documents" class="document-item">
        <h3><a [href]="document.url" target="_blank" rel="noopener noreferrer">{{ document.title }}</a></h3>
        <ul class="snippet-list">
          <li *ngFor="let snippet of document.snippeds" [innerHTML]="snippet"></li>
        </ul>
      </li>
    </ul>
  </div>

  <div *ngIf="hasSearched && !searchResults && !loading && searchTerm">
    <p>検索結果が見つかりませんでした。</p>
  </div>
</div>